import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { abertoFormat, dateFormat } from '@shared/formatters';
import { AbrirAtendimentoComponent } from '@modules/atendimentos/components/abrir-atendimento/abrir-atendimento.component';
import { AtendimentoController } from '@modules/atendimentos/controllers';
import { AtendimentoModel } from '@data/atendimento/models';
import { AuthService } from '@infra/auth/auth.service';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { DetalhesAtendimentoComponent } from '@modules/atendimentos/components/detalhes-atendimento/detalhes-atendimento.component';
import { Coluna } from '@components/table/table.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';

@Component({
  selector: 'app-atendimentos',
  templateUrl: './atendimentos.component.html',
  styleUrls: ['./atendimentos.component.scss'],
})
export class AtendimentosComponent extends BaseListagemComponent<AtendimentoModel> {
  protected filtros: Campo[] = [
    {
      name: 'contrato.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      icon: 'insert_drive_file',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'veiculo.placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'situacao',
      label: 'Situação',
      type: 'select',
      icon: 'check_circle_outline',
      width: '25%',
      selectOptions: {
        items: [
          { label: 'Aberto', value: 'A' },
          { label: 'Fechado', value: 'F' },
        ],
      },
      validators: [],
    },
    {
      name: 'dataHoraAbertura',
      label: 'Período abertura',
      type: 'date-range',
      width: '25%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [],
    },
  ];

  protected acoes: Acao[] = [
    {
      icon: 'add',
      tooltip: 'Abrir atendimento',
      action: this.abrirAtendimento.bind(this),
      disabled: !this.authService.hasPermission('atendimentos', 'INSERIR'),
    },
  ];

  protected colunas: Coluna[] = [
    { name: 'contrato.grupoContrato.numeroGrupoContrato', label: 'Contrato Master' },
    { name: 'numeroAtendimento', label: 'Nº Atendimento' },
    { name: 'descricaoOcorrido', label: 'Descrição Ocorrido', truncate: 30 },
    { name: 'motivoAtendimento.descricao', label: 'Tipo Atendimento' },
    { name: 'veiculo.placa', label: 'Placa' },
    { name: 'veiculo.modelo.descricao', label: 'Modelo' },
    { name: 'dataAgendamento', label: 'Data Agendamento', format: dateFormat },
    { name: 'situacao', label: 'Situação', format: abertoFormat },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Ver detalhes',
          icon: 'visibility',
          action: this.verDetalhes.bind(this),
        },
      ],
    },
  ];

  constructor(public atendimentoController: AtendimentoController, private authService: AuthService, private dialog: MatDialog) {
    super('Atendimentos - Portal do Cliente', atendimentoController);
  }

  protected abrirAtendimento() {
    const ref = this.dialog.open(AbrirAtendimentoComponent, {
      width: '800px',
      height: '600px',
      disableClose: true,
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.filtrar();

        modal.fire({
          title: 'Sucesso!',
          text: 'Atendimento aberto com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });
      }
    });
  }

  private verDetalhes(atendimento: any) {
    const ref = this.dialog.open(DetalhesAtendimentoComponent, {
      width: '800px',
      height: '600px',
      data: { id: atendimento.id },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        modal.fire({
          title: 'Sucesso!',
          text: 'Atendimento atualizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });
      }
    });
  }
}
